import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Loads translation JSON from `src/assets/i18n`. Handles both the global bundle
 * (e.g. `en`) and scoped feature bundles (e.g. `managePreferences/en`), which
 * Transloco requests using the `<scope>/<lang>` convention.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(langOrScope: string) {
    return this.http.get<Translation>(`assets/i18n/${langOrScope}.json`);
  }
}
